// Copyright (c) 2016 Deere & Company

import './registration-review.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import CheckboxWithSearchFilterControlled from '../../../shared/components/facets/checkbox-with-search-filter/controlled';
import DuplicatePinPlateLinkPanel from '../../shared/components/duplicate-pin-plate-link';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import FacetFooter from '../../../shared/components/facets/facet-footer/index';
import FacetsDateRangePickerControlled from '../../../shared/components/facets/date-range-picker/controlled';
import {FormattedMessage} from 'react-intl';
import HighRentalDays from '../../../product/search/components/high-rental-days';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import ProductReportLinks from '../../shared/components/product-report-links';
import ProductSearchBox from '../../shared/components/product-search-box';
import ProductsByCustomerLinkPanel from '../../shared/components/products-by-customer-link-panel';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import Registration from '@deere/cps-it.warranty-model-factory/lib/registration';
import RegistrationResult from './registration-result';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import TabNavigation from '../../../shared/components/tab-navigation';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getNavigationTabs} from '../../shared/services/product-navigation-helper';
import {getRegistrationReviewColumns} from '../services/excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';
import {getStore} from '../../../store-factory';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';
import {isDealerFacetInvalid} from '../../../shared/services/facets';
import {isEntitled} from '../../../shared/services/entitlements';

const filterOptions = [
    [
        'product',
        'pin'
    ],
    [
        'responsibleDealer',
        'name'
    ],
    [
        'responsibleDealer',
        'location',
        'state'
    ],
    [
        'responsibleDealer',
        'account'
    ]
];

const sortOptions = [
    {
        displayName: 'REGISTERED',
        path: ['creationDate']
    },
    {
        displayName: 'DEALER',
        path: [
            'responsibleDealer',
            'account'
        ]
    }
];

function handleDealerFilterInput(text) {

    this.actions.updateDealerAccountFacetInput(text);

}

function handleRegistrationDateChange(registrationDates) {

    this.actions.updateFacetsRegistrationDateRange(registrationDates);

}

function handleDeliveryDateChange(deliveryDates) {

    this.actions.updateFacetsDeliveryDateRange(deliveryDates);

}

function handleRegistrationDateChangeApply() {

    this.actions.updateRegistrationResults(false);

}

function handleRegistrationDateChangeReset() {

    this.actions.resetRegistrationReviewFacets(this.facets.dealerAccountsFacet.allowedDealers);

}

function handleDealerAccountFacetItem(item, isSelected) {

    this.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('registrations');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'registrations');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.registrations.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('registrations', this.exportToExcel.selectedExcelLayout.registrations.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.registrations);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'registrations');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('registrations', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'registrations');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function toggleDealerAccountFacetItems() {

    this.actions.toggleDealerAccountFacetItems(this.facets.dealerAccountsFacet.allowedDealers);

}

function handleDeleteAction(id) {

    this.actions.deleteRegistration(id);

}

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.registrations.name, this.exportToExcel.selectedExcelLayout.registrations.listId, 'registrations');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.registrations.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'registrations');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleDownloadToExcel() {

    this.actions.exportToExcel(
        this.facets,
        this.user.getLocale(),
        this.exportToExcel.selectedExcelLayout.registrations.name,
        this.exportToExcel.selectedExcelLayout.registrations.listId
    );

}

function handleHighRentalDaysDownloadToExcel() {

    this.actions.highRentalDaysExportToExcel(
        this.user.settings,
        this.user.getLocale()
    );

}

class RegistrationReview extends Component {

    state = {
        dateDeliveryPickerExpanded: false,
        dateRequestPickerExpanded: false,
        dealerLocationExpanded: false
    };

    componentWillMount() {

        if (this.props.facets.dealerAccountsFacet.isInitialLoad || !this.props.facets.dealerAccountsFacet.selectedDealers.length) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        if (hasAccess(this.props.security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE')) {

            this.props.actions.updateFactoryDuplicatePinPlateResults();

        }

        this.props.actions.highOnRentalDays(this.props.user.settings);
        this.props.actions.updateRegistrationResults(true);
        this.props.actions.readMachineStatusUpdates(this.props.facets.dealerAccountsFacet.allowedDealers);

    }

    componentWillUnmount() {

        this.props.actions.resetExportToExcelLayout();

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRequestPickerExpanded || this.state.dealerLocationExpanded || this.state.dateDeliveryPickerExpanded;

    render() {

        const countObject = {
            dealerRecommendations: this.props.dealerRecommendationCount,
            factoryDuplicatePinPlateCount: this.props.duplicatePinPlateCount,
            machineStatusUpdates: this.props.machineStatusUpdateCount,
            productSearch: this.props.searchResultsCount,
            registrationReview: this.props.registrations.length,
            transferApproval: this.props.transferApprovalsCount
        };

        let sortedCollection;

        sortedCollection = [...this.props.registrations];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, filterOptions, sortedCollection);

        const list = sortedCollection.map((registration, index) =>
            <RegistrationResult
                deleteAction={this.props::handleDeleteAction}
                key={index}
                registration={registration}
            />
        );

        return (
            <div className='registration-review'>
                <aside>
                    <div className='registration-facets'>
                        <CheckboxWithSearchFilterControlled
                            initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                            isExpanded={this.state.dealerLocationExpanded}
                            list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                            minNumberOfItems={4}
                            onCheckboxListChange={this.props::handleDealerAccountFacetItem}
                            onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                            onInputChange={this.props::handleDealerFilterInput}
                            onToggleAll={this.props::toggleDealerAccountFacetItems}
                            searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                            searchPlaceholder='DEALER_LOCATION_FILTER'
                            title='DEALER_LOCATIONS'
                            valueKey='account'
                        />
                        <FacetsDateRangePickerControlled
                            dateFormat={this.props.dateFormat}
                            dateRange={this.props.facets.registrationDateRange.dateRange}
                            isExpanded={this.state.dateRequestPickerExpanded}
                            maxDate={this.props.facets.registrationDateRange.maxDate}
                            minDate={this.props.facets.registrationDateRange.minDate}
                            onChange={this.props::handleRegistrationDateChange}
                            onClick={this.onAccordionToggle.bind(this, 'dateRequestPickerExpanded')}
                            title='REGISTERED'
                        />
                        <FacetsDateRangePickerControlled
                            dateFormat={this.props.dateFormat}
                            dateRange={this.props.facets.deliveryDateRange.dateRange}
                            isExpanded={this.state.dateDeliveryPickerExpanded}
                            maxDate={this.props.facets.deliveryDateRange.maxDate}
                            minDate={this.props.facets.deliveryDateRange.minDate}
                            onChange={this.props::handleDeliveryDateChange}
                            onClick={this.onAccordionToggle.bind(this, 'dateDeliveryPickerExpanded')}
                            title='DELIVERED'
                        />
                        {this.anyFacetsOpen() ?
                            <FacetFooter
                                disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)}
                                onApply={this.props::handleRegistrationDateChangeApply}
                                onReset={this.props::handleRegistrationDateChangeReset}
                            /> : null}
                    </div>
                    <HighRentalDays
                        highRentalDaysCount={this.props.highRentalDaysCount}
                        onExport={this.props::handleHighRentalDaysDownloadToExcel}
                    />
                    {!this.props.user.privacy.customerPrivate &&
                        <ProductsByCustomerLinkPanel/>
                    }
                    {isEntitled(getStore().getState().user.entitlements, 'duplicatepins') > 0 &&
                    <DuplicatePinPlateLinkPanel/>
    }
                    <div className='report-links'>
                        <ProductReportLinks
                            onAccordionToggle={this.props::handleAccordionToggle}
                            reportsAccordion={this.props.reportsAccordion}
                            reportsRoutes={this.props.reportsRoutes}
                        />
                    </div>
                </aside>
                <main>
                    <div className='primary-actions'>
                        {hasAccess(this.props.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(this.props.user.privacy, 'registrationNotAllowed') &&
                            <a
                                className='primary-action'
                                href={'#/products/register-product'}
                            >
                                <FormattedMessage id='REGISTER_PRODUCT'/>
                            </a>
                        }
                    </div>
                    <ProductSearchBox
                        handleSearch={this.props::handleSearch}
                        searchByDropDown={this.props.searchByDropDown}
                        searchQueryString={this.props.searchQueryString}
                        updateSearchDropDown={this.props.actions.updateSearchDropDown}
                        updateSearchQueryString={this.props.actions.updateSearchQueryString}
                    />
                    <TabNavigation
                        tabs={getNavigationTabs(countObject, this.props.hasSearchResults, this.props.security)}
                    />
                    <div className='product-list'>
                        <RefinableListWidgetWithExportAndLayouts
                            excelLayouts={this.props.exportToExcel.excelLayouts.registrations}
                            onCreateLayout={this.props::handleCreateExcelLayout}
                            onEditLayout={this.props::handleEditExcelLayout}
                            onExport={this.props::handleDownloadToExcel}
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onLayoutChange={this.props::handleExcelLayoutChange}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            selectedLayout={this.props.exportToExcel.selectedExcelLayout.registrations}
                            sortOptions={sortOptions}
                            type={State}
                        />
                        <ListViewShowMore
                            initialShowItems={50}
                            perMoreMultiplier={1.25}
                            showAllOption={true}
                            showPerMore={50}
                            totalItems={list.length}
                        >
                            {list}
                        </ListViewShowMore>
                    </div>
                    <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                    <ExcelLayoutModal
                        excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                        mappingTable={getRegistrationReviewColumns().listColumns}
                        onColumnMove={this.props::handleColumnMove}
                        onColumnPush={this.props::handleColumnPush}
                        onColumnRemove={this.props::handleColumnRemove}
                        onLayoutDelete={this.props::handleExcelLayoutDelete}
                        onLayoutNameBlur={this.props::handleLayoutNameBlur}
                        onLayoutNameChange={this.props::handleLayoutNameChange}
                        onModalClose={this.props::handleExcelLayoutModalClose}
                        onSaveLayout={this.props::handleSaveExcelLayout}
                        onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        sortByList={getSortByList(getRegistrationReviewColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                    />
                </main>
            </div>
        );

    }

}

RegistrationReview.displayName = 'RegistrationReview';
RegistrationReview.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dateFormat: PropTypes.string.isRequired,
    dealerRecommendationCount: PropTypes.number,
    duplicatePinPlateCount: PropTypes.number,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.object,
    hasSearchResults: PropTypes.bool.isRequired,
    highRentalDaysCount: PropTypes.number.isRequired,
    machineStatusUpdateCount: PropTypes.number,
    registrations: PropTypes.arrayOf(PropTypes.instanceOf(Registration)).isRequired,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown),
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResultsCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    transferApprovalsCount: PropTypes.number,
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationReview;



// WEBPACK FOOTER //
// ./src/product/registration-review/components/registration-review.js